<section class="content head">
  <div class="content-wrapper">
    <iaud-audit-title [audit]="audit"></iaud-audit-title>
    <iaud-sid-title [sid]="sid"></iaud-sid-title>
    <iaud-breadcrumb class="capa-details__breadcrumbs" [breadcrumbList]="breadcrumbs"></iaud-breadcrumb>
    <iaud-sid-stepper *ngIf="sidId" [step]="2"></iaud-sid-stepper>
    <div class="capa-details__buttons">
    </div>
    <mat-card class="capa-details__panel" *ngIf="capa">
      <div class="capa-details__panel__header">
        <mat-card-title>Capa Details</mat-card-title>
        <div>
          <button mat-raised-button class="edit-button" (click)="editCapa()" *ngIf="((capa?.status === capaStatus.DRAFT) || canUpdate) && !isApproved">Edit</button>
          <button mat-raised-button class="edit-button" (click)="showAuditHistory()" *ngIf="((capa?.status === capaStatus.DRAFT) || canUpdate) && hasHistory">History</button>
        </div>
      </div>
  
      <div class="capa-details__panel__values">
        <div class="capa-details__panel__values--id iaud-value-container">
          <label for="capa-id">CAPA/EC ID:</label>
          <p id="capa-id">{{ capa.capaId }}</p>
        </div>
  
        <div class="capa-details__panel__values--title iaud-value-container">
          <label for="capa-title">CAPA/EC Title:</label>
          <p id="capa-title">{{ capa.capaTitle }}</p>
        </div>
  
        <div class="capa-details__panel__values--type iaud-value-container">
          <label for="capa-type">CAPA/EC Type:</label>
          <p id="capa-type">{{ capaType }}</p>
        </div>
  
        <div class="capa-details__panel__values--pics iaud-value-container">
          <label for="capa-owner-group">CAPA/EC PICs:</label>
          <p id="pics" *ngFor="let pic of capa.capaPics">
              {{ pic.fullName }}
            </p>
            </div>
  
        <div class="capa-details__panel__values--description iaud-value-container description">
          <label for="capa-description">CAPA/EC Description:</label>
          <p id="capa-description">{{ capa.description }}</p>
        </div>
  
        <div class="capa-details__panel__values--due-date iaud-value-container">
          <label for="capa-due-date">Evidence Submission Due Date</label>
          <p id="capa-due-date">{{ capa.evidenceDueDate | date:dateFormat }}</p>
        </div>
  
        <div class="capa-details__panel__values--status iaud-value-container">
          <label for="capa-status">CAPA/EC Status:</label>
          <p id="capa-status">{{ capa.status }}</p>
        </div>
        <div class="capa-details__panel__values--act-status iaud-value-container">
          <label for="capa-act-status">CAPA/EC Activity Status:</label>
          <p id="capa-act-status">{{ capa.status }}</p>
        </div>
        <div class="capa-details__panel__values--submission iaud-value-container">
          <label for="capa-rights">Evidence Submission Rights:</label>
          <p id="capa-rights" *ngIf="capa.allMustSubmit">All CAPA/EC PICs required to submit</p>
          <p id="capa-rights" *ngIf="!capa.allMustSubmit">Only one of CAPA/EC PICs required to submit</p>
        </div>
      </div>
    </mat-card>
    </div>
</section>
<section class="content" >
  <div class="content-wrapper">
    <iaud-table [data]="evidenceTableData" [options]="evidenceTableOptions" [forceReloadEvent]="forceReloadEvent"
      [dataRefreshCallback]="reloadEvidenceList.bind(this)" [dataDeleteCallback]="deleteData.bind(this)"
      [dataEditCallback]="editEvidence.bind(this)"
      [deleteTitle]="'Delete Evidence'" [deleteText]="'Are you sure you want to delete ${data.evidenceId} evidence?'">
    </iaud-table>
  </div>
</section>
